import React, { useState, useEffect } from "react";
import {
  Form,
  Row,
  Col,
  Input,
  Select,
  Divider,
  DatePicker,
  Segmented,
  Radio,
  Spin,
} from "antd";
import AddPhysicianModalWrapper from "../../modal/AddPhysicianModalWrapper";
import { CustomButton, CustomSecondaryButton } from "../physician_page/styled";
import { patientService } from "../../../services/user";
import { notify } from "../../../utils/helper";
import styled from "styled-components";
import moment from "moment";
import { countryCode } from "../../../utils/countryCode";
import { globalRoles } from "../../../utils/roles";

const { Option } = Select;

export const statusOptions = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];
export const genderOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];
export const bloodGroupOptions = [
  { value: "a+", label: "A+" },
  { value: "a-", label: "A-" },
  { value: "b+", label: "B+" },
  { value: "b-", label: "B-" },
  { value: "ab+", label: "AB+" },
  { value: "ab-", label: "AB-" },
  { value: "o+", label: "O+" },
  { value: "o-", label: "O-" },
];

const FormContainer = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  width: 100%;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  /* &::-webkit-scrollbar-track {
    background:rgb(138, 136, 136);
    border-radius: 10px;
  } */

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
  .ant-picker {
    background: var(--primary-bg);
    color: var(--primary-text-color);
    height: 40px;
    border-radius: 6px;
    border: 1px solid var(--border-color);

    &:hover {
      border-color: #8a3ef4;
    }
  }
  .ant-picker-input > input {
    color: var(--primary-text-color);
  }
  .ant-picker-suffix {
    color: var(--primary-text-color);
  }
  .ant-select-item-option-content{
    display: flex;
    justify-content: start;
    gap: 5px;
  }
  .data{
    border: 1px solid var(--border-color);
    color: var(--primary-text-color);
    padding: 7px 10px;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
  }
  .ant-input-group-addon .ant-select {
    margin: 0;
  }
  .ant-input-group-addon {
    padding: 0;
    border: none;
  }
  .ant-input-group-addon:first-child 
  .ant-select .ant-select-selector {
    border-radius: 0;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;

  }
`;      

const AddPatientModal = ({
  ccm,
  isOpen,
  setOpen,
  isEdit,
  setEdit,
  patientId,
  fetchPatient,
  physicianList,
  userDetails,
  onPatientCreated
}) => {
  const [patientDataById, setpatientDataById] = useState([]);
  const [phoneData, setPhoneData] = useState({
    countryCode: "91",
    number: "",
    short: "IN",
  });
  const [loading, setLoading] = useState(false);
  const isLibraryManager = userDetails?.role === globalRoles.LIBRARY_MANAGER;

    // console.log("physicianList", physicianList);
    // console.log("patientId", patientId);


  const createPatient = async (patientData) => {
    
   
    if (!Array.isArray(patientData.physician)) {
      patientData.physician = patientData.physician ? [patientData.physician] : [];
    }
    
    // Remove physician key from payload if user is not superadmin
    if ((userDetails?.role !== globalRoles.SUPERADMIN || isLibraryManager) || ccm) {
      delete patientData.physician;
    }
    
    try {
      setLoading(true);
      if (isEdit) {
        // console.log("patientData", patientData);
        const response = await patientService.update(patientId?.id, patientData);
        notify("success", "Patient Updated Successfully.");
      } else {
        // console.log("patientData", patientData);
        const response = await patientService.create(patientData);
        notify("success", "Patient Created Successfully.");
        if (onPatientCreated && response?.data?.id) {
          onPatientCreated(response.data.id);
        }
      }
      setOpen(false);
      if (setEdit) setEdit(false);
      setLoading(false);
      fetchPatient();
    } catch (error) {
      if(error?.data?.message) {
        notify("error", error.data.message);

      }
      setLoading(false);
    }
  };


  const [form] = Form.useForm();
  useEffect(() => {
    if (isEdit) {
      const hasCcm =
      Array.isArray(patientId?.ccm) && patientId.ccm.length > 0;

      form.setFieldsValue({
        name: patientId?.nameText || patientId?.name || "",
        email: patientId?.email || "",
        mobile: {
          countryCode: patientId?.mobile?.countryCode || "+91",
          number: patientId?.mobile?.number || "",
        },
        ...(hasCcm
          ? { ccm: patientId.ccm.map(p => p.id) }
          : { physician: patientId.physician.map(p => p.id) }
        ),
        status: patientId?.status || "",
      });
    } else {
      form.setFieldsValue({
        name: "",
        email: "",
        mobile: {
          countryCode: "+1",
          number: "",
        },
        physician: [],
        status: true,
      });
    }
  }, [patientDataById, form, isEdit]);

  const onClose = () => {
    if (setEdit) setEdit(false);
    setOpen(false);
  };

  const handleCountryChange = (value, option) => {
    const selectedCountry = countryCode.find(
      (country) => country?.name === value
    );
    const updatedPhoneData = {
      ...phoneData,
      countryCode: selectedCountry?.dial_code,
      short: selectedCountry?.code,
    };
    setPhoneData(updatedPhoneData);
  };

  const handlePhoneChange = (e) => {
    const phoneValue = e.target.value;
    setPhoneData({
      ...phoneData,
      number: phoneValue,
    });
  };

  return (
    <AddPhysicianModalWrapper
      show={isOpen}
      setShow={onClose}
      title={
        isEdit ? (
          <div className="row-flex flex-column">
            <h3 className="font-18 font-semibold text-primary mb-5">
              Update Patient
            </h3>
            <span className="font-15 text-secondry">
              Edit the patient’s information.
            </span>
          </div>
        ) : (
          <div className="row-flex flex-column">
            <h3 className="font-18 font-semibold text-primary mb-5">
              Add New Patient
            </h3>
            <span className="font-15 text-secondry">
              Enter the details to add a new patient to the platform.
            </span>
          </div>
        )
      }
      footer={null}
      width={570}
      keyClose={false}
      className="custom-detail-modal"
    >
    <Spin spinning={loading}>
      <Form
        form={form}
        layout="vertical"
        onFinish={createPatient}
        // requiredMark="optional"
      >
        <FormContainer>
          <Row gutter={[24, 8]}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Full Name"
                rules={[
                  { required: true, message: "Please input the full name!" },
                ]}
              >
                <Input placeholder="Enter Full Name" size="large" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name={["mobile", "number"]}
                label="Phone Number"
                rules={[
                  {
                    required: true,
                    message: "Please input your phone number!",
                  },
                  // { pattern: /^\d{10}$/, message: 'Phone number must be exactly 10 digits'},
                ]}
              >
                <Input
                  // maxLength={10}
                  addonBefore={
                    <Form.Item
                      name={["mobile", "countryCode"]}
                      noStyle
                      rules={[{ required: true, message: "Code is required" }]}
                      initialValue={"+1"}
                    >
                      <Select
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        style={{ width: 80 }}
                        showSearch
                        dropdownStyle={{ minWidth: 220 ,maxHeight: 200, overflowY: 'auto', overflowX: 'hidden' }}
                        listHeight={110}
                        onChange={handleCountryChange}
                        placeholder="Select country code"
                        optionLabelProp="label"
                        // dropdownStyle={{minWidth: 250}}
                        filterOption={(input, option) =>
                          option?.label.toLowerCase().includes(input.toLowerCase()) ||
                          option?.name?.toLowerCase().includes(input.toLowerCase())
                        }
                      >
                        {countryCode.map((country) => (
                          <Option
                            key={country.dial_code}
                            value={`+${country.dial_code}`}
                            name={country.name}
                            label={
                                `+${country.dial_code}`
                            }
                          >
                            <span style={{ fontSize: "10px" }}>
                              {country.code}
                            </span>
                            <span> {country.name}</span>
                            <span> +{country.dial_code}</span>
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  }
                  placeholder="Phone number"
                  onChange={handlePhoneChange}
                  onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault(); // block non-numeric input
                  }
                }}
                />
              </Form.Item>
            </Col>

            {(userDetails?.role === globalRoles.SUPERADMIN || isLibraryManager) && (
              <Col span={24}>
                <Form.Item
                  name={ccm ? "ccm" : "physician"}
                  label={ccm ? "Coordinator" : "Physician"}
                  rules={[
                    { required: true, message: `Please select a ${ccm ? 'Coordinator' : 'Physician'}!`},
                  ]}
                >
                  <Select 
                    maxTagCount="responsive"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    mode="multiple"
                    showSearch 
                    dropdownStyle={{ maxHeight: 200, overflowY: 'auto', overflowX: 'hidden' }}
                    listHeight={115}
                    placeholder={`Select ${ccm ? 'Coordinator' : 'Physician'}`} 
                    loading={loading} 
                    filterOption={(input, option) =>
                      option?.label.toLowerCase().includes(input.toLowerCase()) ||
                      option?.value?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {physicianList.map((physician) => (
                      <Option
                        key={physician.id}
                        label={`${physician.name1 || physician.name} : ${physician?.specialty} - ${physician?.email}`}
                        value={physician.id}
                        style={{borderBottom: "1px solid var(--border-color)"}}
                      >
                        {physician.name1 || physician.name} : {physician?.specialty} - {physician?.email}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            )}

            <Col span={24}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: "Please input your email!" },
                  {
                    type: "email",
                    message: "Please enter a valid email address!",
                  },
                ]}
              >
                <Input placeholder="Email address" size="large" />
              </Form.Item>
            </Col>

            {/* <Col span={12}>
              <Form.Item
                name="gender"
                label="Gender"
                rules={[
                  { required: true, message: "Please input your gender!" },
                  {
                    type: "Select",
                    message: "Please enter a valid gender",
                  },
                ]}
                initialValue={"male"}
              >
                <Radio.Group>
                  <Radio value="male">Male</Radio>
                  <Radio value="female">Female</Radio>
                </Radio.Group>
              </Form.Item>
            </Col> */}

            {/* <Col span={12}>
              <Form.Item
                name="dob"
                label="Date of Birth"
                rules={[
                  {
                    required: true,
                    message: "Please input your date of birth!",
                  },
                  {
                    type: "DatePicker",
                    message: "Please enter a valid date of birth",
                  },
                ]}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  onChange={(date, dateString) => {
                    const formattedDate = moment(date).format("DD/MM/YYYY");
                  }}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col> */}

            {/* <Col span={12}>
              <Form.Item
                name="bloodGroup"
                label="Blood Group"
                rules={[
                  { required: true, message: "Please input your blood group!" },
                  {
                    type: "Text",
                    message: "Please enter a valid blood group",
                  },
                ]}
              >
                <Select
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  placeholder="Select Blood Group"
                  options={bloodGroupOptions}
                  size="large"
                />
              </Form.Item>
            </Col> */}

            {/* <Col span={12}>
              <Form.Item
                name="state"
                label="State"
                rules={[
                  { required: true, message: "Please input your state!" },
                  {
                    type: "Text",
                    message: "Please enter a valid state",
                  },
                ]}
              >
                <Input placeholder="State" size="large" />
              </Form.Item>
            </Col> */}

            {/* <Col span={12}>
              <Form.Item
                name="city"
                label="City"
                rules={[
                  { required: true, message: "Please input your city!" },
                  {
                    type: "Text",
                    message: "Please enter a valid city",
                  },
                ]}
              >
                <Input placeholder="City" size="large" />
              </Form.Item>
            </Col> */}

            {/* <Col span={12}>
              <Form.Item
                name="country"
                label="Country"
                rules={[
                  { required: true, message: "Please input your country!" },
                  {
                    type: "Text",
                    message: "Please enter a valid country",
                  },
                ]}
              >
                <Select
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  placeholder="Select Country"
                  size="large"
                  showSearch
                >
                  {countryCode.map((item) => (
                    <Option key={item.name} value={item.name}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col> */}

            {/* <Col span={12}>
              <Form.Item
                name="zip"
                label="Pincode"
                rules={[
                  {
                    required: true,
                    message: "Please input your pincode!",
                  },
                  {
                    type: "string",
                    pattern: /^[0-9]{6}$/,
                    message: "Pincode must be a 6-digit number",
                  },
                ]}
              >
                <Input placeholder="Pincode" />
              </Form.Item>
            </Col> */}

            {/* <Col span={12}>
              <Form.Item  label="Status" initialValue={true}>
                <Select
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  placeholder="Select Status"
                  options={statusOptions}
                  size="large"
                />
              </Form.Item>
            </Col> */}

            {/* <Col span={24}>
              <Form.Item
                name="address"
                label="Address"
                rules={[
                  { required: true, message: "Please input your address!" },
                  {
                    type: "Text",
                    message: "Please enter a valid address",
                  },
                ]}
              >
                <Input placeholder="Address" size="large" />
              </Form.Item>
            </Col> */}
          </Row>
        </FormContainer>

        <Divider style={{ margin: "20px 0" }} />

        <Row>
          <Col span={24} className="d-flex justify-end gap-12">
            <CustomSecondaryButton
              onClick={() => {
                if (setEdit) setEdit(false);
                setOpen(false);
              }}
            >
              Cancel
            </CustomSecondaryButton>
            <CustomButton htmlType="submit">
              {loading ? "Processing..." : isEdit ? "Update" : "Add Patient"}
            </CustomButton>
          </Col>
        </Row>
      </Form>
    </Spin>
    </AddPhysicianModalWrapper>
  );
};

export default AddPatientModal;
